import React, { Suspense, lazy, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Hero from '../components/Hero';

const Platforms = lazy(() => import('../components/Platforms'));
const ClientServices = lazy(() => import('../components/ClientServices'));
const BusinessSection = lazy(() => import('../components/BusinessSection'));
const RestaurantPreview = lazy(() => import('../components/RestaurantPreview'));
const PartnersStrip = lazy(() => import('../components/PartnersStrip'));
const Coverage = lazy(() => import('../components/Coverage'));
const AppDownload = lazy(() => import('../components/AppDownload'));
const FAQ = lazy(() => import('../components/FAQ'));
const FinalCTA = lazy(() => import('../components/FinalCTA'));

const SectionFallback = () => <div className='min-h-[8rem]' aria-hidden='true' />;

const Home = () => {
  const location = useLocation();

  useEffect(() => {
    if (!location.hash) return;
    const id = location.hash.replace('#', '');
    const tryScroll = () => {
      const el = document.getElementById(id);
      if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
    };
    tryScroll();
    const t = setTimeout(tryScroll, 450);
    return () => clearTimeout(t);
  }, [location.hash]);

  return (
    <div>
      <Hero />
      <Suspense fallback={<SectionFallback />}>
        <Platforms />
        <ClientServices />
        <BusinessSection />
        <RestaurantPreview />
        <PartnersStrip />
        <Coverage />
        <AppDownload />
        <FAQ />
        <FinalCTA />
      </Suspense>
    </div>
  );
};

export default Home;
